@import "../../../styles/base";
@import "../../../components/design-system/Button/styles/surfaces";

// These sizings are for the mobile view — the desktop view is defined below inside a media query

.DialogContainer {
  overflow: auto;
  height: 100%;
  width: 100%;
  position: fixed;
}

.Aligner {
  min-height: 100vh;
  display: flex;
  justify-content: stretch;
  justify-items: stretch;
  align-items: flex-end;
  padding: 0.5rem;
}

.Dialog {
  width: 100%;
  display: flex;
  justify-content: center;
  @include white-surface;
}

.LeftAlign {
  text-align: left;
}

.Centre {
  text-align: center;
}

.Main {
  background: $white;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  position: relative;
  width: 100%;
  box-shadow: $elevate-shadow-3;
  animation: modal-open-dialog 0.2s ease-out;
  padding: 1rem 1.5rem;

  .FullHeight & {
    min-height: calc(100vh - 2rem);
  }

  @media screen and (prefers-reduced-motion: reduce) {
    animation: none;
  }

  &:focus {
    outline: none;
  }

  form {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
  }
}

.IsLoading .Main {
  overflow: hidden;
}

@media screen and (min-width: $tablet) {
  .Aligner {
    justify-content: center;
    align-items: center;
    padding: 1rem;
  }

  .Main {
    padding: 1.5rem;

    .x-small & {
      max-width: 368px;
    }

    .small & {
      max-width: 560px;
    }

    .medium & {
      max-width: 752px;
    }

    .large & {
      max-width: 944px;
    }

    .max & {
      max-width: 1136px;
    }

    .auto & {
      width: auto;
      max-width: 100%;
    }
  }
}

@keyframes modal-open-dialog {
  0% {
    opacity: 0;
  }

  50% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
